import FilteredDateHistoryFilter from '@di-shared/features/history/filtered/FilteredDateHistoryFilter';

interface FilteredDateHistoryFilterPageProps {
  vin: string;
}

export default function FilteredDateHistoryFilterPage({vin}: FilteredDateHistoryFilterPageProps) {
  return <FilteredDateHistoryFilter vin={vin} />;
}
